const vi = {
    // ====== Common ======
    common: {
        getStarted: "Bắt đầu ngay",
        login: "Đăng nhập",
        signInWithGoogle: "Đăng nhập với Google",
        back: "Quay lại",
        viewAll: "Xem tất cả",
        explore: "Khám phá",
        upload: "Tải ảnh lên",
        viewSamples: "Xem mẫu",
        textPrompt: "Mô tả text",
        takePhoto: "Chụp trực tiếp",
        generateFromText: "Tạo từ mô tả",
        systemOnline: "Hệ thống hoạt động",
        aiTools: "công cụ AI",
        industries: "chuyên ngành",
        termsOfService: "Điều khoản sử dụng",
        bySigningIn: "Bằng việc đăng nhập, bạn đồng ý với điều khoản sử dụng.",
        copyright: "© 2025 MindAI · Nền tảng AI chuyên ngành",
        imagesPerDay: "ảnh/ngày",
        loading: "Đang tải...",
        signOut: "Đăng xuất",
        goToDashboard: "Vào Dashboard",
        error: "Lỗi",
    },

    // ====== Home Page ======
    home: {
        badge: "Nền tảng AI chuyên ngành hàng đầu",
        heroTitle1: "Trí tuệ nhân tạo",
        heroTitle2: "cho mọi ngành nghề",
        heroDescription: "Bộ công cụ AI chuyên biệt cho Kiến trúc, Spa & Thẩm mỹ, Chỉnh sửa ảnh. Mỗi ngành — một giải pháp tối ưu.",
        servicesByIndustry: "Dịch vụ theo ngành",
        stats: {
            aiTools: "Công cụ AI",
            industriesCount: "Chuyên ngành",
            processing: "Thời gian xử lý",
        },
        features: {
            fast: { title: "Siêu nhanh", desc: "Xử lý <5 giây" },
            secure: { title: "Bảo mật", desc: "Mã hoá E2E" },
            multiPlatform: { title: "Đa nền tảng", desc: "Web & Mobile" },
        },
        // Bottom tabs
        tabs: {
            services: "Dịch vụ",
            pricing: "Bảng giá",
            cases: "Dự án",
            profile: "Hồ sơ",
        },
        // Pricing section
        pricing: {
            title: "Bảng giá",
            subtitle: "Chọn gói phù hợp với nhu cầu của bạn",
            free: "Miễn phí",
            popular: "Phổ biến",
            perDay: "ảnh/ngày",
            perMonth: "ảnh/tháng",
            threads: "luồng",
            currentPlan: "Gói hiện tại",
            upgrade: "Nâng cấp",
            startFree: "Bắt đầu miễn phí",
            features: {
                dailyLimit: "Giới hạn hàng ngày",
                concurrent: "Xử lý đồng thời",
                monthlyEst: "Ước tính hàng tháng",
                allTools: "Tất cả công cụ AI",
                support: "Hỗ trợ",
                priority: "Ưu tiên",
                basic: "Cơ bản",
            },
        },
    },

    // ====== Login ======
    login: {
        welcomeBack: "Chào mừng bạn",
        subtitle: "Đăng nhập để sử dụng MindAI",
    },

    // ====== Dashboard ======
    dashboard: {
        greeting: {
            morning: "Chào buổi sáng",
            afternoon: "Chào buổi chiều",
            evening: "Chào buổi tối",
        },
        chooseIndustry: "chọn chuyên ngành",
        statusBar: "Hệ thống hoạt động · 12 công cụ AI · 3 chuyên ngành",
    },

    // ====== Sidebar ======
    sidebar: {
        home: "Tổng quan",
        architecture: "Kiến trúc",
        spa: "Spa AI",
        photo: "Ảnh AI",
    },

    // ====== Industries ======
    industries: {
        architecture: {
            name: "Kiến Trúc AI",
            nameShort: "Kiến Trúc",
            nameEn: "Architecture",
            description: "Bản vẽ AI & render 3D",
            descriptionLong: "Thiết kế, render và biến đổi không gian kiến trúc bằng trí tuệ nhân tạo.",
            tools: "4 công cụ",
            statusBar: "AI tiên tiến · Render real-time",
        },
        spa: {
            name: "Spa & Thẩm Mỹ AI",
            nameShort: "Spa & Thẩm Mỹ",
            nameEn: "SPA & Wellness",
            description: "Chăm sóc da cá nhân hoá",
            descriptionLong: "Phân tích da, tư vấn, thử makeup và kiểu tóc ảo bằng AI.",
            tools: "4 công cụ",
            statusBar: "AI tham khảo · Bảo mật · Ảnh xoá sau 24h",
        },
        photoEdit: {
            name: "Chỉnh Sửa Ảnh AI",
            nameShort: "Chỉnh Sửa Ảnh",
            nameEn: "Photo Editing",
            description: "Chỉnh sửa chuyên nghiệp 1 click",
            descriptionLong: "Xoá phông, nâng cấp, chỉnh màu và tạo ảnh nghệ thuật bằng AI.",
            tools: "4 công cụ",
            statusBar: "JPG, PNG, WebP · Max 20MB · Bảo mật",
        },
    },

    // ====== Architecture Tools ======
    archTools: {
        interior: { name: "Thiết kế nội thất AI", desc: "Tải ảnh phòng lên — AI redesign theo phong cách: hiện đại, tối giản, Scandinavian, Nhật Bản.", features: ["Redesign phòng", "Phong cách", "Nội thất", "Render 3D"] },
        exterior: { name: "Phối cảnh ngoại thất", desc: "Tạo phối cảnh mặt tiền, sân vườn, công trình từ phác thảo hoặc văn bản.", features: ["Mặt tiền", "Sân vườn", "Công trình", "Biệt thự"] },
        render: { name: "Render kiến trúc", desc: "Chuyển bản vẽ 2D thành render siêu thực với ánh sáng, chất liệu.", features: ["Bản vẽ → Render", "Chất liệu", "Ánh sáng", "360°"] },
        style: { name: "Chuyển đổi phong cách", desc: "Biến ảnh thành phong cách khác: Cổ điển → Hiện đại, Đông → Tây.", features: ["Cổ điển → Hiện đại", "Đông → Tây", "Tối giản", "Nâng cấp"] },
    },

    // ====== Spa Tools ======
    spaTools: {
        skin: { name: "Phân tích da mặt AI", desc: "Upload ảnh khuôn mặt — AI phân tích: mụn, nám, lỗ chân lông, độ ẩm.", features: ["Phân tích mụn", "Đo độ ẩm", "Phát hiện nám", "Lỗ chân lông"] },
        consult: { name: "Tư vấn thẩm mỹ AI", desc: "AI phân tích khuôn mặt và gợi ý thẩm mỹ phi phẫu thuật.", features: ["Gợi ý filler", "Contour", "Trước/Sau", "Cá nhân hoá"] },
        makeup: { name: "Makeup ảo AI", desc: "Thử makeup: cưới, dạ tiệc, tự nhiên, Hàn Quốc — xem trước ngay.", features: ["Makeup cưới", "Hàn Quốc", "Dạ tiệc", "Tự nhiên"] },
        hair: { name: "Thiết kế kiểu tóc AI", desc: "Thử kiểu tóc, nhuộm trên ảnh thật. Tìm kiểu phù hợp khuôn mặt.", features: ["Đổi kiểu tóc", "Thử nhuộm", "Khuôn mặt", "Xu hướng"] },
    },

    // ====== Photo Edit Tools ======
    photoTools: {
        bg: { name: "Xoá phông & Xoá vật thể", desc: "Tự động xoá background, xoá người hoặc vật thể — chỉ 1 click.", features: ["Xoá background", "Xoá vật thể", "Xoá người", "Thay phông"] },
        upscale: { name: "Nâng cấp chất lượng ảnh", desc: "Tăng độ phân giải 2x-4x, khôi phục chi tiết, giảm noise.", features: ["2x", "4x", "Chi tiết", "Giảm noise"] },
        color: { name: "Chỉnh màu AI", desc: "Cân bằng màu tự động, tăng cường ánh sáng, bộ lọc chuyên nghiệp.", features: ["Auto color", "HDR", "Film filter", "Sáng/Tối"] },
        art: { name: "Tạo ảnh nghệ thuật", desc: "Chuyển ảnh thường thành: sơn dầu, watercolor, anime, sketch.", features: ["Sơn dầu", "Watercolor", "Anime", "Sketch"] },
    },

    // ====== Dashboard features ======
    dashFeatures: {
        architecture: [
            { label: "Nội thất" }, { label: "Ngoại thất" },
            { label: "Render" }, { label: "Phong cách" },
        ],
        spa: [
            { label: "Phân tích da" }, { label: "Tư vấn" },
            { label: "Makeup" }, { label: "Kiểu tóc" },
        ],
        photoEdit: [
            { label: "Xoá phông" }, { label: "Nâng cấp" },
            { label: "Chỉnh màu" }, { label: "Nghệ thuật" },
        ],
    },
};

export type TranslationKeys = typeof vi;
export default vi;

